import { requestEnterPriceContact, requestInABoxContact, requestPatagoniaContact, requestGiveawayContact, requestAutomationContact, requestZapierContact, requestShopifyContact, requestResellerForm } from './landings.actions';
export const enterpriseFormDispatcher = dispatch => ({
  onSubmitRequest: request => dispatch(requestEnterPriceContact({
    request
  }))
});
export const inABoxFormDispatcher = dispatch => ({
  onSubmitRequest: () => dispatch(requestInABoxContact())
});
export const patagoniaFormDispatcher = dispatch => ({
  onSubmitRequest: () => dispatch(requestPatagoniaContact())
});
export const giveawayFormDispatcher = dispatch => ({
  onSubmitRequest: () => dispatch(requestGiveawayContact())
});
export const automationFormDispatcher = dispatch => ({
  onSubmitRequest: () => dispatch(requestAutomationContact())
});
export const zapierFormDispatcher = dispatch => ({
  onSubmitRequest: () => dispatch(requestZapierContact())
});
export const shopifyFormDispatcher = dispatch => ({
  onSubmitRequest: () => dispatch(requestShopifyContact())
});
export const resellerFormDispatcher = dispatch => ({
  onSubmitRequest: () => dispatch(requestResellerForm())
});